import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";

import { useNavigationStore } from "../hooks/NavigationContext";
import { useSelfServeContextStore } from "../hooks/SelfServeContext";

import { SelfServeHeader } from "./components/SelfServeHeader";
import { SelfServeProgressBar } from "./components/SelfServeProgressBar";
import { TOTAL_3_STEPS, TOTAL_4_STEPS } from "./step";

interface ISelfServeSkeletonProps {
  children: React.ReactNode;
}

export const SelfServeSkeleton: React.FC<ISelfServeSkeletonProps> = ({
  children,
}) => {
  const [{ currentStep }] = useNavigationStore(["currentStep"]);
  const [{ brandOrders }] = useSelfServeContextStore(["brandOrders"]);
  const currentStepNumber = Number(currentStep);
  const TOTAL_STEPS =
    brandOrders && brandOrders.length > 0 ? TOTAL_4_STEPS : TOTAL_3_STEPS;
  const progressNumber = Math.floor((currentStepNumber / TOTAL_STEPS) * 100);

  return (
    <SelfServeSkeletonWrapper data-test-id="self-serve-wrapper">
      <SelfServeHeader issueType="" />
      <SelfServeProgressBar progress={progressNumber} />
      <ContentWrapper data-test-id="content-wrapper">
        <Center>{children}</Center>
      </ContentWrapper>
    </SelfServeSkeletonWrapper>
  );
};

const SelfServeSkeletonWrapper = styled(Column)`
  width: 100%;
  background-color: transparent;
  height: auto;
  min-height: 100vh;
`;

const ContentWrapper = styled(Column).attrs({
  align: "center",
  justify: "center",
})`
  width: 100%;
  height: 100%;
  padding: ${getSpacing("1x", "2x")};
  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("1x")};
  }
  > * {
    width: 100%;
  }
`;

const Center = styled(Column).attrs({
  justify: "center",
})`
  max-width: 1168px;
`;
